// extracted by mini-css-extract-plugin
module.exports = {"ErrorIndicator":"styles_ErrorIndicator__2EjWS","ErrorIndicator_Text":"styles_ErrorIndicator_Text__1cAs5"};